(function () {
  const mq = window.matchMedia('(max-width: 749px)');

  function init() {
    if (!mq.matches) return;

    // Dawn: media-gallery enthält meist den Slider
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const slider = gallery.querySelector('.slider') || gallery.querySelector('.product__media-list');
    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll('.slider__slide, .product__media-item'));
    if (slides.length <= 1) return;

    // --- LOOP LOGIK für Prev/Next Buttons ---
    const prevBtn = gallery.querySelector('button[name="previous"], .slider-button--prev');
    const nextBtn = gallery.querySelector('button[name="next"], .slider-button--next');

    function currentIndex() {
      const x = slider.scrollLeft;
      const w = slider.clientWidth || 1;
      return Math.round(x / w);
    }

    function goTo(i) {
      const w = slider.clientWidth;
      slider.scrollTo({ left: i * w, behavior: 'smooth' });
      setActiveDot(i);
    }

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', (e) => {
        // Dawn handled evtl. schon -> wir nur "wrap"
        const i = currentIndex();
        if (i === 0) {
          e.preventDefault();
          e.stopPropagation();
          goTo(slides.length - 1);
        }
      }, true);

      nextBtn.addEventListener('click', (e) => {
        const i = currentIndex();
        if (i === slides.length - 1) {
          e.preventDefault();
          e.stopPropagation();
          goTo(0);
        }
      }, true);
    }

    // --- DOTS ---
    let dotsWrap = gallery.querySelector('.byten-slider-dots');
    if (!dotsWrap) {
      dotsWrap = document.createElement('div');
      dotsWrap.className = 'byten-slider-dots';

      slides.forEach((_, idx) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'byten-slider-dot' + (idx === 0 ? ' is-active' : '');
        b.addEventListener('click', () => goTo(idx));
        dotsWrap.appendChild(b);
      });

      // Dots direkt in den Slider hängen
      const mediaWrapper = gallery.closest('.product__media-wrapper');
      (mediaWrapper || gallery).appendChild(dotsWrap);
    }

    function setActiveDot(i) {
      const dots = Array.from(dotsWrap.querySelectorAll('.byten-slider-dot'));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
    }

    // Active dot beim Swipen aktualisieren
    let raf = null;
    slider.addEventListener('scroll', () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setActiveDot(currentIndex()));
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', init);
  mq.addEventListener?.('change', () => location.reload());
})();

